<template>
  <div class="container-outline">
    <div class="register">
      <div class="title">Register</div>
      <div class="top-squence">
        <head-register :dataSquence="{ id: 8, title: 'rekening' }" />
      </div>
      <div class="content-register">
        <div class="container">
          <p class="sub-title">REKENING BANK NASABAH UNTUK PENYETORAN DAN PENARIKAN MARGIN</p>
          <span class="rekening-warning"
            >Rekening Bank Nasabah Untuk Penyetoran dan Penarikan Margin (hanya rekening dibawah ini yang dapat Saudara pergunakan untuk lalulintas margin)
          </span>
          <form @submit.prevent="registerKYC">
            <div class="gof-jafets">
              <div class="form-group">
                <label class="detail-alamat">Nama Bank *</label>
                <input
                  type="text"
                  class="form-input"
                  placeholder="Masukin nama Bank"
                  v-model="form.bank_account[0].name"
                  @keyup="form.bank_account[0].name = form.bank_account[0].name.replace(/[^a-zA-Z\s]/g, '')"
                  required
                />
              </div>
              <div class="form-group">
                <label class="detail-alamat">Nama Pemilik *</label>
                <input
                  type="text"
                  class="form-input"
                  placeholder="Masukin nama pemilik bank"
                  v-model="form.bank_account[0].account_name"
                  @keyup="form.bank_account[0].account_name = form.bank_account[0].account_name.replace(/[^a-zA-Z\s]/g, '')"
                  required
                />
              </div>
              <div class="form-group">
                <label class="detail-alamat">Cabang *</label>
                <input type="text" class="form-input" placeholder="Masukin cabang bank" v-model="form.bank_account[0].branch" required />
              </div>
              <div class="form-group">
                <label for="" class="detail-alamat">No Rekening *</label>
                <input
                  type="text"
                  class="form-input"
                  placeholder="Masukkan No Rekening Anda"
                  v-model="form.bank_account[0].account_no"
                  @keyup="form.bank_account[0].account_no = form.bank_account[0].account_no.replace(/[^\d]/g, '')"
                  required
                />
              </div>

              <div class="form-group">
                <label class="detail-alamat">No Telepon *</label>
                <input
                  type="text"
                  class="form-input"
                  placeholder="Masukin no telepon terdaftar di bank"
                  v-model="form.bank_account[0].phonenumber"
                  @keyup="form.bank_account[0].phonenumber = form.bank_account[0].phonenumber.replace(/[^\d]/g, '')"
                  required
                />
              </div>
              <div class="form-group">
                <label class="detail-alamat">Jenis Rekening </label>
                <select name="" id="" v-model="form.bank_account[0].type_account">
                  <option value="" selected disabled>Pilih jenis rekening</option>
                  <option value="giro">Giro</option>
                  <option value="tabungan">Tabungan</option>
                  <option value="lainnya">Lainnya</option>
                </select>
              </div>
            </div>
            <div class="form-group form-checkbox">
              <input type="checkbox" class="checkbox" required v-model="form.has_confirm_bank" />
              <label class="label--checkbox">
                Dengan ini saya setuju atas seluruh data REKENING NASABAH yang saya isi adalah BENAR dan sesuai dengan
                <span id="toggle-btn" class="ketentuan">Peraturan</span> yang berlaku
              </label>
            </div>

            <div class="button">
              <router-link to="/register-datakeuangan"><button class="btn-scondary">Sebelumnya</button></router-link>
              <button class="btn-primer" type="submit">
                <div v-show="loading == false">Selanjutnya</div>
                <Loader class="loading" v-show="loading" />
              </button>
            </div>
          </form>

          <div class="self-modal" v-show="selected">
            <div class="content-modal">
              <div class="title-modal">
                <p v-show="modalShow == 1">
                  Syarat dan Ketentuan Bank Artha Graha Internasional
                </p>
                <p v-show="modalShow == 2">
                  Syarat dan Ketentuan Tabungan Icon
                </p>
              </div>
              <div class="body-modal">
                <div v-show="modalShow == 1">
                  <SKBagi />
                </div>
                <div v-show="modalShow == 2">
                  <SKIconBagi />
                </div>
              </div>
              <div class="footer-modal">
                <div class="btn-primer show-content" @click="(setuju = 1), (selected = false)" v-if="modalShow == 1">
                  <div v-show="isLoadingaccount == false">Submit</div>
                  <Loader class="loading" v-show="isLoadingaccount" />
                </div>
                <div class="btn-primer show-content" @click="(setuju2 = 2), (selected = false)" v-else>
                  <div v-show="isLoadingaccount == false">Submit</div>
                  <Loader class="loading" v-show="isLoadingaccount" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import Loader from "../assets/Loading";
import SKBagi from "../assets/filedownload/SKBagi.vue";
import SKIconBagi from "../assets/filedownload/SKIconBagi.vue";
import HeadRegister from "./component/HeadRegister.vue";

export default {
  components: {
    Loader,
    SKBagi,
    SKIconBagi,
    HeadRegister,
  },
  data() {
    return {
      bankType: false,
      counter: 4,
      modalShow: "",
      setuju: "",
      setuju2: "",
      selected: false,
      cabangGiro: [],
      cabangCMB: [],
      loading: false,
      form: {
        bank_account: [
          {
            name: "",
            branch: "",
            account_no: "",
            phonenumber: "",
            type_account: "",
            account_name: "",
          },
        ],
        has_confirm_bank: false,
        step: "account",
      },
      idRek: "",
      account_cimb: "",
      account_giro: "",
      status: "",
      isLoadingaccount: false,
      checkedStatement: "",
      bank_rdk: "",
      typeRek: "",
    };
  },
  mounted() {
    const type = localStorage.getItem("platform");
    if (type == "Jafets" || type == "GoFX") {
      this.bankType = true;
    } else {
      this.bankType = false;
    }

    this.$store.dispatch("getCustomer").then((res) => {
      axios.get("/v2/kyc/bank/account/" + res._id).then((resAccouunt) => {
        this.form.bank_account[0].name = resAccouunt.data.data.customer.bank_account[0].name;
        this.form.bank_account[0].branch = resAccouunt.data.data.customer.bank_account[0].branch;
        this.form.bank_account[0].account_no = resAccouunt.data.data.customer.bank_account[0].account_no;
        this.form.bank_account[0].phonenumber = resAccouunt.data.data.customer.bank_account[0].phonenumber;
        this.form.bank_account[0].type_account = resAccouunt.data.data.customer.bank_account[0].type_account;
        this.form.bank_account[0].account_name = resAccouunt.data.data.customer.bank_account[0].account_name;

        // this.form.bank_account[0][1].name = resAccouunt.data.data.customer.bank_account[1].name;
        // this.form.bank_account[0][1].branch = resAccouunt.data.data.customer.bank_account[1].branch;
        // this.form.bank_account[0][1].account_no = resAccouunt.data.data.customer.bank_account[1].account_no;
        // this.form.bank_account[0][1].phonenumber = resAccouunt.data.data.customer.bank_account[1].phonenumber;
        // this.form.bank_account[0][1].type_account = resAccouunt.data.data.customer.bank_account[1].type_account;

        this.form.has_confirm_bank = resAccouunt.data.data.customer.has_confirm_bank;
      });
    });
  },
  computed: {
    customerId() {
      return this.$store.getters.customerData._id;
    },
  },
  methods: {
    isNumber(event) {
      const pattern = /[0-9]/;

      let inputChar = String.fromCharCode(event.charCode);
      if (event.keyCode != 8 && !pattern.test(inputChar)) {
        event.preventDefault();
      }
    },
    validationAccount() {
      this.isLoadingaccount = true;
      let account;
      let check;
      if (this.setuju == 1) {
        account = this.account_cimb;
        check = "0";
        this.form.ac_cimb = this.account_cimb;
      } else {
        account = this.account_giro;
        check = "1";
        this.form.ac_giropos = this.account_giro;
      }
      axios
        .post("/v1/user/validate_account", {
          check: check,
          account_number: account,
        })
        .then((res) => {
          if (res.data.status == 200) {
            this.isLoadingaccount = false;
            this.status = 200;
            this.selected = false;
          }
        })
        .catch((err) => {
          this.isLoadingaccount = false;
          this.status = err.response.status;
        });
    },
    openModal(e) {
      this.selected = true;
      this.modalShow = e;
    },
    registerKYC() {
      this.loading = true;
      axios
        .put("/v2/kyc/bank/account/" + this.customerId, this.form)
        .then((res) => {
          this.loading = false;
          let status = res.data.data.status_code;
          if (status == "00") {
            this.$router.push("/register-datalampiran");
          } else if (status == "2004") {
            this.loading = false;
            this.$notify({
              group: "foo",
              title: "<h5>Data sudah di submit</h5>",
              type: "error",
              duration: 2000,
            });
          } else {
            this.loading = false;
            this.$notify({
              group: "foo",
              title: "<h5>kesalahan sistem</h5>",
              type: "error",
              duration: 2000,
            });
          }
        })
        .catch(() => {
          this.loading = false;
          this.$notify({
            group: "foo",
            title: "<h5>Cek kembali inputan anda</h5>",
            type: "error",
            duration: 2000,
          });
        });
    },
  },
};
</script>

<style scoped>
.container-outline {
  width: 70%;
}
.li-active:nth-child(5)::before {
  border: dashed 1px #c59733;
}

.info-rekening {
  color: #ffa400;
  position: relative;
  left: -75px;
}

.konfirmasi-akun {
  font-size: 13px;
}

.clickCheck {
  width: 17px;
  height: 20px;
  position: absolute;
  top: -7px;
  left: -2px;
  z-index: 3;
  cursor: pointer;
}

.rekening-warning {
  font-size: 13px;
  margin-bottom: 1rem;
}

.form-checkbox {
  margin-top: 50px;
  font-size: 14px;
  color: #707070;
  display: flex;
}

.label-radio {
  width: 185px;
  cursor: pointer;
}

.outer {
  margin: 10px 25px 10px 15px;
}

.register {
  margin: 46px 0;
}

label {
  font-size: 14px;
  width: 205px;
  display: inline-block;
}

.detail-alamat {
  width: 175px;
  margin: 0 0 0 30px;
}

.form-input {
  width: 73%;
  text-transform: capitalize;
}

select {
  width: 73%;
  height: 45px;
}

.tempat {
  width: 41%;
  margin: 0 25px 0 0;
}

.tanggal {
  width: 25%;
  border-bottom-right-radius: 0;
  border-top-right-radius: 0;
}

.pos-telepon {
  width: 25%;
}

.jabatan {
  height: 35px;
  width: 10%;
}

.tahun {
  margin: 0 0 0 30px;
}

.identitas {
  width: 20%;
  margin: 0 32px 0 0;
  background-position-x: 88%;
}

.no-identitas {
  width: 50%;
}

.input-button {
  width: 50px;
  height: 50px;
  text-align: center;
  display: inline-flex;
  justify-content: center;
  align-items: center;
  position: relative;
  top: 6px;
  left: -1px;
  border: solid 1px #707070;
  background-color: #6454f0;
  border-bottom-right-radius: 10px;
  border-top-right-radius: 10px;
}

.icon-calender {
  font-size: 20px;
  color: white;
}

.content-register {
  box-shadow: 0 0 2rem 0 rgba(136, 152, 170, 0.15);
  background: #ffffff;
  border-radius: 5px;
}

.title {
  font-size: 25px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  margin: 0 0 50px;
}

.navigation {
  margin: 0 0 50px;
  font-size: 10px;
  font-weight: 500;
  font-stretch: normal;
  font-style: normal;
}
.container {
  width: 90%;
  padding-top: 45px;
}

.nav-root {
  display: flex;
  justify-content: space-between;
  margin: 0 0 50px;
  position: relative;
}

.list-root {
  list-style: none;
  height: 65px;
  width: 40%;
  padding: 20px 15px;
  text-align: center;
  color: rgba(112, 112, 112, 0.5);
}

.active {
  border-top-right-radius: 30px;
  border-bottom-right-radius: 30px;
  border-top: solid 2px #000e22;
  border-right: solid 2px #000e22;
  border-bottom: solid 2px #000e22;
  background-color: #1f354a;
  color: white;
  position: relative;
  text-align: center;
}

.active:first-child {
  border-top-left-radius: 15px;
}

.active:last-child {
  border-top-right-radius: 15px;
  border-bottom-right-radius: 0;
}

.active::before {
  z-index: -1;
  position: absolute;
  content: "";
  display: inline-block;
  width: 50px;
  height: 65px;
  background-color: #1f354a;
  top: -2px;
  left: -41px;
  border: 2px solid #000e22;
}

.active:first-child::before {
  opacity: 0;
}

.button {
  display: flex;
  justify-content: space-between;
  padding: 76px 15px;
}

.sub-title {
  margin: 0 0 35px;
  font-size: 18px;
  font-weight: bold;
}

.sub-sub-title {
  margin: 30px 0;
  font-weight: bold;
}

.arrow {
  margin-left: 10px;
  margin-right: 10px;
  border: solid #6454f0;
  border-width: 0 3px 3px 0;
  display: inline-block;
  padding: 4px;
  transform: rotate(45deg);
  vertical-align: super;
}

.wrap-arrow {
  position: absolute;
  display: inline-block;
  width: 56px;
  height: 48px;
  /* border: solid 1px; */
  right: 50px;
  top: 1px;
  border-radius: 10px;
  text-align: center;
  padding: 15px 9px;
  background: white;
}

.input-cimb {
  border: none;
  width: 100%;
}

.input-cimb:focus {
  border-color: #fff !important;
  outline: none;
}

.company-id {
  font-weight: bold;
  font-size: 13px;
}

.company-id td {
  border: solid 1px #707070;
  padding: 5px 10px;
}

.signature-pad {
  width: 42.5%;
  height: 150px;
  border: solid 1px #a0a0a0;
  text-align: center;
}

.signature-pad p {
  position: relative;
  top: 50%;
  transform: translateY(-50%);
  color: #ddd;
}

.authority {
  display: flex;
  margin-bottom: 10px;
}

.authority p {
  width: 35%;
}

.content {
  font-size: 12px;
  text-align: justify;
}

.sub-content {
  font-weight: bold;
}
.li-checbox {
  /* width: 70%; */
  flex: 2;
  border-bottom: solid 1px #ddd;
  display: flex;
  align-items: center;
  height: 65px;
}

.signature {
  flex: 1;
  border: solid 1px #ddd;
}

.li-checbox:last-child {
  border: none;
}

.li-checbox label {
  font-size: 12px;
  margin: 15px;
  width: 100%;
}

.footer-modal {
  display: flex;
  justify-content: center;
}

@media (min-width: 768px) and (max-width: 1190px) {
  .list-root {
    font-size: 13px;
  }
  .active {
    padding: 10px;
    text-align: center;
    font-size: 13px;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .active::before {
    width: 28px;
    left: -25px;
  }

  label,
  select,
  .form-input {
    width: 100%;
  }
}

@media (max-width: 768px) {
  .container-outline {
    width: 90%;
  }

  li > span {
    display: none;
  }

  .form-input,
  select,
  .input-button {
    width: 100%;
  }

  .birtday,
  .kecamatan,
  .input-rt-rw {
    width: 100% !important;
    text-align: left;
  }

  .register {
    margin: 20px 0;
  }

  .title {
    font-size: 18px;
    margin: 0 0 20px;
  }

  .sub-title {
    margin-bottom: 20px;
  }

  .top-squence {
    width: 100%;
    padding: 15px 10px;
  }

  .container {
    width: 100%;
    padding: 25px 20px;
  }

  .identitas,
  .form-ktp-bagi,
  .tanggal-aktif,
  .tempat,
  .kecamatan,
  .input-rt-rw {
    margin: 0 0 10px;
  }

  .detail-alamat,
  .rt-rw {
    margin: 0 0 0.5rem;
  }

  .form-checkbox {
    align-items: flex-start;
  }

  .label--checkbox {
    margin-left: 15px;
  }

  .button {
    display: block;
    width: 100%;
    text-align: center;
  }

  .btn-scondary,
  .btn-primer {
    width: 100%;
  }

  .btn-scondary {
    margin-bottom: 20px;
  }
}
</style>
